import { render, staticRenderFns } from "./ChatImage.vue?vue&type=template&id=d1fac2de&scoped=true&"
import script from "./ChatImage.vue?vue&type=script&lang=js&"
export * from "./ChatImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatImage.vue?vue&type=style&index=0&id=d1fac2de&prod&scoped=true&lang=css&"
import style1 from "./ChatImage.vue?vue&type=style&index=1&id=d1fac2de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fac2de",
  null
  
)

export default component.exports